import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import iconClosedAlert from "../../../../assets/images/icons/iconClosedAlert.svg";
import iconDMInstagramColorModal from "../../../../assets/images/icons/iconDMInstagramColorModal.svg";
import instaImagenDm from "../../../../assets/images/image_DM.png";
import instaImagenDmEn from "../../../../assets/images/image_DM_EN.png";
import instaImagenDmDe from "../../../../assets/images/image_DM_DE.png";
import iconChevronLeft from "../../../../assets/images/icons/iconChevronLeft.svg";
import iconChevronRight from "../../../../assets/images/icons/iconChevronRight.svg";
import "../../../../assets/styles/scss/scss_files/general/_general.scss";
import iconCheckCircleWhite from "../../../../assets/images/icon-Check-Circle-White.svg";

export const PCSharedInstaDM = ({ setOpenModal, setShared, pcInfo }) => {
  const [t] = useTranslation("global");
  const [changeButon, setChangeButon] = useState(false);
  // const ROOT_URL = process.env.REACT_APP_URL;
  const goInsta = () => {
    window.open("https://www.instagram.com/", "_blank");
  };
  let image;

  switch (window?.navigator?.language?.slice(0, 2)) {
    case "es":
      image = instaImagenDm;
      break;
    case "de":
      image = instaImagenDmDe;
      break;
    case "en":
      image = instaImagenDmEn;
      break;
    default:
      image = instaImagenDmEn;
      break;
  }
  const ROOT_URL = process.env.REACT_APP_MY_URL;

  let copy = `${t("dashboard.modalSharedCopyLinkWhatsApp")}
  ${ROOT_URL}/${pcInfo.domain_name}`;

  const handleChange = () => {
    toast.success(t("information.copiedCorrectly"));
    // window.open("https://www.instagram.com/", "_blank");
    setChangeButon(true);
  };

  return (
    <>
      <div className="alert-confirmation-budget sharedLinks m-0 d-flex ">
        <div className="header-alert-budget header-link">
          <Button
            className="modalShared iconBack"
            onClick={() => setShared("links")}
          >
            <img src={iconChevronLeft} alt="instaColor" />
          </Button>
          DM Instagram
          <Button className="closedAlert" onClick={() => setOpenModal(false)}>
            <img className="iconCheck" src={iconClosedAlert} alt="asdasd" />
          </Button>
        </div>

        <div className="sharedBody">
          <div className="divAlertConfirmation">
            <p className="text-start mb-0 pb2">
              {t("dashboard.modalSharedDMDescription")}&nbsp;
              <span className="textBoldRRSS">
                {t("dashboard.modalSharedDMDescription2")}
              </span>
              &nbsp;
              {t("dashboard.modalSharedDMDescription3")}
            </p>
          </div>
          <div className="sharedBodyImg">
            <img
              className="iconCheck sharedSize"
              src={image}
              alt="Icon Check"
            />
          </div>
          <div className="sharedBodycopy">
            <p className="">
              {t("dashboard.modalSharedGreetings")}
              {pcInfo.studio_name} ...
            </p>
            <CopyToClipboard text={copy}>
              <Button
                className={
                  changeButon === false ? "ButonRRSS" : "ButonRRSSGreen"
                }
                onClick={changeButon === false && (() => handleChange())}
              >
                {changeButon === false ? (
                  `${t("information.copy")}`
                ) : (
                  <>
                    <img
                      className="iconCheckButtonRRSS"
                      src={iconCheckCircleWhite}
                      alt=""
                    ></img>
                    <p> {t("information.copying")} </p>
                  </>
                )}
              </Button>
            </CopyToClipboard>
          </div>
        </div>
        <div className="links" onClick={() => goInsta()}>
          <Button className="modalShared">
            <img
              className="iconCheck"
              src={iconDMInstagramColorModal}
              alt="instaColor"
            />
            <span>DM Instagram</span>
          </Button>
          <img className="go" src={iconChevronRight} alt="go" />
        </div>
      </div>
    </>
  );
};
